import { mdiAccountCheck } from '@mdi/js';
import React from 'react';
import { ProviderActionButton } from './provider-action-button';

interface IProviderDoneButtonProps {
    count?: number;
    disabled?: boolean;
    onClick: () => void;
}

export const ProviderDoneButton: React.FunctionComponent<IProviderDoneButtonProps> = (
    props: IProviderDoneButtonProps,
): React.ReactElement => {
    return <ProviderActionButton icon={mdiAccountCheck} tooltipPrefix="to Done for Provider" {...props} />;
};

